import React from 'react';
import {
  FormControl,
  Grid,
  TextField,
  Box,
  Typography,
  Button,
} from '@mui/material';

export default function RegisterForm({
  control,
  Controller,
  errors,
  customer,
}) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '500px',
        mx: 'auto',
        px: { xs: 2, sm: 3 },
      }}
    >
      {/* ข้อมูลเข้าสู่ระบบ */}
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          color: '#c2410c',
          fontWeight: 600,
        }}
      >
        ข้อมูลเข้าสู่ระบบ
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Controller
          name={'username'}
          control={control}
          defaultValue={customer ? customer.username : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="อีเมล"
              type="email"
              fullWidth
              required
              error={!!errors.username}
              helperText={errors.username && 'กรุณาใส่อีเมล'}
              sx={{ mb: 3 }}
            />
          )}
        />

        <Controller
          name={'password'}
          control={control}
          defaultValue={customer ? customer.password : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รหัสผ่าน"
              type="password"
              fullWidth
              required
              error={!!errors.password}
              helperText={errors.password && 'กรุณาใส่รหัสผ่าน'}
            />
          )}
        />
      </Box>

      {/* ข้อมูลส่วนตัว */}
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          color: '#c2410c',
          fontWeight: 600,
        }}
      >
        ข้อมูลส่วนตัว
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            name="firstname"
            control={control}
            defaultValue=""
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label="ชื่อจริง"
                fullWidth
                required
                error={!!errors.firstname}
                helperText={errors.firstname && 'กรุณาใส่ชื่อจริง'}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="lastname"
            control={control}
            defaultValue=""
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label="นามสกุล"
                fullWidth
                required
                error={!!errors.lastname}
                helperText={errors.lastname && 'กรุณาใส่นามสกุล'}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="nickname"
            control={control}
            defaultValue=""
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label="ชื่อเล่น"
                fullWidth
                required
                error={!!errors.nickname}
                helperText={errors.nickname && 'กรุณาใส่ชื่อเล่น'}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="tel"
            control={control}
            defaultValue=""
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label="เบอร์โทรศัพท์"
                fullWidth
                required
                error={!!errors.tel}
                helperText={errors.tel && 'กรุณาใส่เบอร์โทรศัพท์'}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="line"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField {...field} label="ไลน์ไอดี (ไม่บังคับ)" fullWidth />
            )}
          />
        </Grid>
      </Grid>

      {/* ปุ่มสมัครสมาชิก */}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          sx={{
            py: 1.8,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1.1rem',
            fontWeight: 600,
            color: '#000',
            background: 'linear-gradient(to right, #ff9a9e 0%, #fad0c4 100%)',
            boxShadow: '0 4px 15px 0 rgba(255, 154, 158, 0.4)',
            '&:hover': {
              background: 'linear-gradient(to right, #fad0c4 0%, #ff9a9e 100%)',
              boxShadow: '0 6px 20px 0 rgba(255, 154, 158, 0.6)',
            },
          }}
        >
          สมัครสมาชิก
        </Button>
      </Box>
    </Box>
  );
}
